import {createAction, props} from '@ngrx/store';
import {MappedHttpErrorResponse} from '@adnova/jf-ng-components';
import {KundeDTO, KundeFilterDTO, PageableDTO} from '../../openapi/fakturierung-openapi';


export class KontaktActions {

  private static readonly prefix = '[Kontakt] ';

  public static readKunden = createAction(
    this.prefix + 'Read kunden at Kontakt component.',
    props<{
      betriebId: string,
      filterDto: KundeFilterDTO,
      pageableDto: PageableDTO,
    }>(),
  );

  public static setDisplayedIds = createAction(
    this.prefix + 'Set kunden ids that should be displayed at kontakt component.',
    props<{
      kundeDtos: KundeDTO[],
    }>(),
  );

  public static clearDisplayedKunden = createAction(
    this.prefix + 'Clear kunden that should be displayed at kontakt component.',
    props<{
      error: MappedHttpErrorResponse,
    }>(),
  );

  public static readMoreKunden = createAction(
    this.prefix + 'Read more kunden at kontakt component.',
    props<{
      betriebId: string,
      filterDto: KundeFilterDTO,
      pageableDto: PageableDTO,
    }>(),
  );

  public static addDisplayedIds = createAction(
    this.prefix + 'Adds more kunden ids that should be displayed at kontakt component.',
    props<{
      kundeDtos: KundeDTO[],
    }>(),
  );

  public static addDisplayedId = createAction(
    this.prefix + 'Adds a single kunden-id that should be displayed at kontakt component.',
    props<{
      kundeId?: string,
    }>(),
  );

  public static updateTextFilter = createAction(
    this.prefix + 'Updates the text-filter at kontakt component.',
    props<{
      textFilter: string,
    }>(),
  );

  public static triggerReadMoreKunden = createAction(
    this.prefix + 'Updates the pageableDto to load more options at kontakt component.',
  );

}
